import { Box } from "@mui/material";
import * as React from "react";
import UOM_Component from "./UOM_Component";

export default function UOM() {
  return (
    <Box>
      <UOM_Component />
    </Box>
  );
}